import { render, staticRenderFns } from "./taskContent.vue?vue&type=template&id=460c5c05"
import script from "./taskContent.vue?vue&type=script&lang=js"
export * from "./taskContent.vue?vue&type=script&lang=js"
import style0 from "./taskContent.vue?vue&type=style&index=0&id=460c5c05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports